const theme = {
  fontFamily: "Roboto",
  textColor: "rgba(0, 0, 0, 0.68)",
  backgroundColor: "#fff",
  palette: {
    primary1Color: "#00bcd1",
    primary2Color: "#fe7a51",
    textColor: "#5f5c62",
    canvasColor: "#F7F7F7",
    borderColor: "#e6e6e6",
  },
  button: {
    height: 48,
  },
  raisedButton: {
    primaryColor: "#fe7a51",
  },
  textField: {
    backgroundColor: "#ffffff",
    textColor: "#464646",
    hintColor: "#969696",
    floatingLabelColor: "#969696",
    borderColor: "#e6e6e6",
  },
  floatingActionButton: {
    color: "#f58720",
  },
  bottomNavigation: {
    backgroundColor: "#ffffff",
    selectedColor: "#fe7a51",
  },
  stepper: {
    backgroundColor: 'transparent',
    hoverBackgroundColor: "#fe7a51",
    iconColor: "#fe7a51",
    hoveredIconColor: "red",
    inactiveIconColor: "red",
    textColor: "#fe7a51",
    disabledTextColor: "#fe7a51",
    connectorLineColor: "red",
  },
  radioButton: {
    background: "#fe7a51",
  },
};

export default theme;



// WEBPACK FOOTER //
// src/config/theme.js